<template>
    <div class="bg-white rounded-md -space-y-px grid grid-cols-1 ">
        <!-- On: "bg-blue-50 border-blue-200 z-10", Off: "border-gray-200" -->
        <div    v-for="(option, optionValue) in unsnoozeNotificationOptions"
                class="">
            <div    :class="[$data._unsnoozeNotificationSetting === optionValue ? 'bg-blue-50 border-blue-200 z-10' : 'border-gray-200', cursorForButton]"
                    class="flex items-start my-2 relative border rounded-md p-4"
                    @click="setNotification(optionValue)">
                <div class="flex items-center h-5">
                    <input :id="`permission-${optionValue}`" :checked="$data._unsnoozeNotificationSetting === optionValue"
                           class="h-4 w-4 text-blue-600"
                           name="privacy_setting"
                           type="radio"
                    >
                </div>
                <label :id="`unsnooze-notification-${optionValue}`" :class="cursorForButton" class="ml-3 flex-col">
                    <!-- On: "text-blue-900", Off: "text-gray-900" -->
                    <span   :class="[$data._unsnoozeNotificationSetting === optionValue ? 'text-blue-900' : 'text-gray-900']"
                            class="block text-sm leading-5 font-medium">
                            {{ option.text }}
                        </span>
                    <!-- On: "text-blue-700", Off: "text-gray-500" -->
                    <span   :class="[$data._unsnoozeNotificationSetting === optionValue ? 'text-blue-700' : 'text-gray-500']"
                            class="block text-sm leading-5">
                            {{ option.desc }}
                        </span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import UndecoratedLink from "@/components/EnterpriseDashboard/undecorated-link.vue";

export default {
    name: "UnsnoozeNotificationRadio",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {},
    emits: [],
    props: {
        unsnoozeNotificationSetting: String,
    },
    data() {
        return {
            unsnoozeNotificationOptions: {
                'do_not_notify': {
                    'text': 'Do Not Notify',
                    'desc': 'Never notify me of an alarm being un-snoozed.'
                },
                'always_notify': {
                    'text': 'Always Notify',
                    'desc': 'Always notify me of an alarm being un-snoozed.'
                },
                'notify_smartly': {
                    'text': 'Limited Notifications',
                    'desc': 'Send me the un-snooze notification, but do not send me an alarm re-notification for an alarm which has been un-snoozed within 15 minutes.'
                },
            },
            _unsnoozeNotificationSetting: this.unsnoozeNotificationSetting,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        setNotification(optionValue) {
            // If the user cannot change the setting, do nothing
            if (! this.canEditEscalation) {
                return
            }
            this._unsnoozeNotificationSetting = optionValue;
        },
    },
    computed: {
        cursorForButton() {
            return this.canEditEscalation ? 'cursor-pointer' : 'cursor-not-allowed';
        },
        canEditEscalation() {
            return this.permissions.can('edit_alarm_reminder');
        },
    },
    watch: {
        unsnoozeNotificationSetting: {
            handler: function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    this._unsnoozeNotificationSetting = newVal;
                }
            },
            deep: true
        },
        _unsnoozeNotificationSetting: {
            handler: function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.$emit('update:unsnoozeNotificationSetting', newVal)
                }
            },
            deep: true
        }
    },
}
</script>

<style scoped>

</style>